import { render } from "./BaseBack.vue?vue&type=template&id=0fe896d6&scoped=true"
import script from "./BaseBack.vue?vue&type=script&lang=js"
export * from "./BaseBack.vue?vue&type=script&lang=js"

import "./BaseBack.vue?vue&type=style&index=0&id=0fe896d6&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe896d6"]])

export default __exports__